"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTCategory = void 0;
const validation_1 = require("../validation");
var NFTCategory;
(function (NFTCategory) {
    NFTCategory["PARCEL"] = "parcel";
    NFTCategory["ESTATE"] = "estate";
    NFTCategory["WEARABLE"] = "wearable";
    NFTCategory["ENS"] = "ens";
    NFTCategory["EMOTE"] = "emote";
})(NFTCategory = exports.NFTCategory || (exports.NFTCategory = {}));
(function (NFTCategory) {
    NFTCategory.schema = {
        type: 'string',
        enum: Object.values(NFTCategory)
    };
    NFTCategory.validate = (0, validation_1.generateValidator)(NFTCategory.schema);
})(NFTCategory = exports.NFTCategory || (exports.NFTCategory = {}));
//# sourceMappingURL=nft-category.js.map